import React, { Component } from "react";
import GLOBALS from '../utils/Constants';
import CryptoJS from 'crypto-js'
import moment from 'moment-timezone';
import UserService from './users-service';

export default class FormdataService {

    static sharedInstance = FormdataService.sharedInstance == null ? new FormdataService() : this.sharedInstance;

    constructor() {
       // UserService.sharedInstance.checkIfTokenIsValid();
    }

    async getFormDataByType(params){
        const formBody = UserService.sharedInstance.urlEncodeParams(params);

        const response = await fetch(GLOBALS.API_GET_FORM_DATA_BY_TYPE+"&"+formBody, {
            method: 'GET',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded'
            },
        });

        const responseJson = await response.json();
        try {
            UserService.sharedInstance.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            console.error("error");
        }
    }

    async saveFormData(params){
        const formBody = UserService.sharedInstance.urlEncodeParams(params);

        const response = await fetch(GLOBALS.API_SAVE_FORM_DATA, {
            method: 'POST',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded',
            },
            body: formBody
        });
        const responseJson = await response.json();
        try {
            UserService.sharedInstance.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            console.error(error);
        }
    }

    async getDropdownDataForAddForm(params){
        const formBody = UserService.sharedInstance.urlEncodeParams(params);

        const response = await fetch(GLOBALS.API_GET_DROPDOWN_DATA_FOR_ADD_FORM+"&"+formBody, {
            method: 'GET',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded',
            }
        });

        const responseJson = await response.json();
        try {
            UserService.sharedInstance.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            console.error(error);
        }
    }

    async updateFormData(params){
        const formBody = UserService.sharedInstance.urlEncodeParams(params);

        const response = await fetch(GLOBALS.API_UPDATE_DROPDOWN_DATA, {
            method: 'PUT',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded',
            },
            body: formBody
        });

        const responseJson = await response.json();
        try {
            return responseJson;
        } catch (error) {
            console.error(error);
        }
    }

    async deleteFormData(params){
        const formBody = UserService.sharedInstance.urlEncodeParams(params);

        const response = await fetch(GLOBALS.API_DELETE_DROPDOWN_DATA, {
            method: 'DELETE',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded',
            },
            body: formBody
        });
        const responseJson = await response.json();
        try {
            UserService.sharedInstance.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            console.error(error);
        }
    }

    async updateCustomName(param){
        try{
            const body = UserService.sharedInstance.urlEncodeParams(param);

            const option = {
                method: 'PUT',
                headers: {
                    'Content-Type':'application/x-www-form-urlencoded'
                },body:body
            }
            const response = await fetch(GLOBALS.API_UPDATE_CUSTOM_NAME,option);
            const jsonResponse = await response.json();

            return jsonResponse;
        }catch(err){
            console.error('Error:',err);
        }
    }
    /*** End of API Calls ***/

}
